import { Box, Stack, Text } from "@chakra-ui/react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import Introduction from "./Introduction/Introduction.js";
import { getInstitutionBasicData } from "../../services/Institution.js";
// import Economics from './EconomicsOfCinema/Economics.js';
import General from "./General/General.js";
import MyTabsNested from "../../components/MyTabsNested.js";
import Basic from "./General/Basic.js";
import Preface from "./Introduction/Preface.js";
import Establishment from "./Introduction/Establishment.js";
import Teams from "./Introduction/Teams.js";
import { useSelector } from "react-redux";
import Sections from "../../CommonComponents/Sections.js";
import MyAccordionNested from "../../components/MyAccordionNested.js";

const EditInstitutionRecord = () => {
  const { alias } = useParams();
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const personalityType = pathParts?.[1];
  const navigate = useNavigate();
  const [institutionTitle, setInstitutionTitle] = useState();
  const previewEnabled = useSelector((state) => state.preview.isEnabled);
  const tabs = useMemo(() => {
    let initialTabs = [
      {
        id: "general",
        title: "General",
        Component: General,
        subTabs: [
          { id: "primary", title: "Primary", Component: Basic },
          { id: "sections", title: "Sections", Component: Sections },
        ],
      },
      {
        id: "introduction",
        title: "Introduction",
        Component: Introduction,
        subTabs: [
          { id: "preface", title: "Preface", Component: Preface },
          {
            id: "establishment",
            title: "Establishment",
            Component: Establishment,
          },
          { id: "team", title: "Team", Component: Teams },
        ],
      },
    ];

    return initialTabs;
  }, []);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getInstitutionBasicData(alias);

          if (result) {
            setInstitutionTitle(result?.full_name);
          }
        }
      } catch (error) {
        console.error("Error fetching institution data:", error);
      }
    };

    getBasicData();
  }, [alias]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    if (pathParts?.length === 3 && alias) {
      // Redirect to the default tab/subTab
      navigate(
        `/${personalityType}/${alias}/${tabs[0].id}/${tabs[0].subTabs[0].id}`,
        { replace: true },
      );
    }
  }, [location.pathname, alias, navigate, tabs, pathParts, personalityType]);

  return (
    <Stack py="5px">
      <Box px="4" pb="4">
        <Text fontSize={"22px"} fontWeight={"600"}>
          {institutionTitle}
        </Text>
      </Box>
      {previewEnabled ? (
        <MyAccordionNested
          orientation="vertical"
          list={tabs}
          urlBasePath={`/${personalityType}`}
          tabSegmentPosition={2}
          subTabSegmentPosition={3}
        />
      ) : (
        <MyTabsNested
          orientation="vertical"
          list={tabs}
          urlBasePath={`/${personalityType}`}
          tabSegmentPosition={2}
          subTabSegmentPosition={3}
        />
      )}
    </Stack>
  );
};

export default EditInstitutionRecord;
